import { redirect } from 'shared/helpers/redirect';
import { hasHidePolygon } from 'shared/hooks/useHasHidePolygon';

// For safety while we are developing the homepage
// we intercept any call to NH LSRP here and force a page refresh.
// This should be removed once it's live.
export const handleLsrpMapViewRouting = (url: string) => {
    const regexLsrpMapView = new RegExp(
        '/(for-sale|to-rent|new-homes)/map/(property|flats|houses|bungalows|retirement).+$'
    );

    const urlMatches = url.match(regexLsrpMapView);

    const hasCustomArea = hasHidePolygon(url);

    if (!hasCustomArea && urlMatches && urlMatches.length > 0) {
        redirect(url);
    }
};
